import React from "react";
import { PokerPatience } from "components/PokerPatience";
import { SmallScreenNotice } from "components/SmallScreenNotice";

function App() {
  return (
    <>
      <SmallScreenNotice />
      <PokerPatience />
    </>
  );
}

export default App;
